{
"models": {
        "CHD10-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "CHD10-1042E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARD12-2060S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1144W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-2060W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "SLC07-1072A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IBC20-1144S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC12-1060A":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "FLY16-2100A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC16-1108A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "AED08-1042E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARD12-2060A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "AED08-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC20-1144A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-2060E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1192A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-4180E":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "IBC20-1192G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC12-1060W":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "HLC12-5192A":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IBC20-1192D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-3120E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2108E":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IDC12-3120G":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2108G":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IDC12-3120A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2108A":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "HLC12-5192W":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "CHD10-3108A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC12-5192S":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "CHD10-3108E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-1060S":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "IDC12-3120W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2108W":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IDC12-3120S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2108S":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "CHD10-2096A":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "HLC16-1120S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "CHD10-2096E":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "HLC16-1120W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1168A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-2108S":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IDC14-4192W":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "HLC14-2108W":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IDC14-1060W":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "IBC16-1144G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC14-5180S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC16-1120A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC12-5180A":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IBC16-1144A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-2108A":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "SLC07-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC14-4180G":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "AHD10-2060W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-3144S":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "AHD10-2060S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-3144W":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "IDC12-2072G":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-3132E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARC16-2072S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-1042W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARC16-2072W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-1042S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC12-1060E":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "IDC14-3144A":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "AHD10-2060E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-3144E":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "IDC14-3144G":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "AHD10-2060A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARD12-1042E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARC16-2072A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARC16-2072E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CLC08-2108E":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IBC16-1060S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-1060S":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "CLC08-2108A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IBC16-1060W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-1060W":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "CLC08-1060W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC14-2072S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CLC08-1060S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC14-2072W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC20-1144D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "CLC08-2108W":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IBC16-1060A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC16-1060G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "CLC08-2108S":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC12-1060G":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "CLC08-1060E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC14-2072A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-2072G":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CLC08-1060A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC12-2078W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARD12-3108S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IBC20-1144G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-3132G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARD12-3108W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC20-1132D":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC20-1120W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC20-1072A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC20-1120S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC16-1192W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "ARD12-3108A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARD12-3108E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC20-1072W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC14-1060E":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "HLC20-1120A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC20-1072S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC12-3144W":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "CLC08-1030A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC12-3144S":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "AHD10-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC12-2072A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC20-1168A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-3144G":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IDC12-3144E":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IDC12-3144A":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IDC20-1144E":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "AHD10-1042S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC16-1156E":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "AHD10-1042W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC16-1180W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1180S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC14-1036S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "CLC08-2084W":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "CLC08-2084S":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IBC16-1180G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1180D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1180A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC14-4144W":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "CLC08-2084E":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IBC16-1168G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1144D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "CLC08-2084A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IBC16-1144S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC20-1132S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC20-1132W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC12-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC12-1042E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC12-1042G":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC20-1132A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC14-4180A":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "IDC14-3132S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1132D":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC20-1132G":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC12-1042S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "SHD07-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.75
        },
        "IDC20-1168S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-1042W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC20-1192S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC16-1096S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1168W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-1048E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC16-1192S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC12-3144A":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IDC16-1096A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC14-2084S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC16-1096E":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1096D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1096G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC12-3144S":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IDC12-5192A":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "HLC12-3144W":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IDC16-1144W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "CHD10-2084E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC14-2096A":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC14-3120A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "CHD10-2084A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-2084W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC14-3096S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-3096W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC16-1156D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-1144D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-2096W":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IBC16-1156G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-1144A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1156A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-2096S":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC14-3096A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC20-1120E":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC12-4192W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-1048G":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-4168S":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC12-4192S":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC20-1144A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-3132A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC16-1072W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-4180A":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "IDC20-1060D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC16-1072S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC20-1144W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-4192E":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC20-1144S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-4192A":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC14-4180S":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "IDC14-4168W":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC14-4180W":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "HLC16-1072A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC16-1144W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC12-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC20-1180A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC14-4144A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "CLC08-1072W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "CLC08-1072S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC20-1180W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-3108A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC12-1042W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC20-1180S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC12-1042S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "CLC08-1072E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC14-4144S":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "FLY16-3120A":{
            "penalty":0.0,
            "totalHorsePower":6.0
        },
        "IDC14-3108G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "SLC07-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC14-4144W":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "CLC08-1072A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IBC30-1120D":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IBC30-1108A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC20-1060A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC30-1108D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC16-1132W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "FLY16-2088A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC14-2072A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC30-1108S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC20-1060S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "SHD07-3108A":{
            "penalty":0.0,
            "totalHorsePower":2.25
        },
        "IDC20-2192S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC30-1108W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC20-1060W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC14-2072W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC16-1132G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1132D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-2072S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-1036G":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-2084A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC16-1132A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC12-2060A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARD12-3132S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC12-2072W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC12-2060S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "SLC07-2108A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "HLC12-2060W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-1036E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC30-1156D":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IDC16-2180E":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "AHD10-2084W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "AHD10-2084S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-1144G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1192D":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "AHD10-2084E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "CHD10-1060E":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "IBC16-1144D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "AHD10-2084A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "CHD10-1060A":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "IDC14-4168E":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC12-5180W":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IDC14-2084G":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC20-1120W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC20-1120S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "ARC16-4144W":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "ARD12-4144W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-2120W":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "ARD12-4144S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC16-1132S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC20-1120G":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC20-1120D":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC16-1132W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC20-1120A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "ARD12-4144E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARC16-4144E":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "ARD12-4144A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-1036W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-4144A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC16-1084W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ALC08-2084S":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC14-1060G":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "ALC08-2084W":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC12-3132W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IBC20-1180W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-4192G":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "IDC12-3132S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IBC20-1180S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ALC08-2084A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC16-1084D":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1084E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ALC08-2084E":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC16-1084A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1180D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-3132G":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IBC20-1180G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC20-1180A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC16-1084S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-3132A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARD12-2096W":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "HLC14-1036W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-4192A":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "HLC14-2084S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC12-2120W":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "HLC14-2084W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC12-2120S":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "IDC14-1036A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "SLC07-1060A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARC16-3120W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-2084A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC12-2120A":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "SHD07-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.75
        },
        "IDC12-2072E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-1132D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC20-1156A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC20-1096A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-1132E":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-4192A":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "HLC16-2180A":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC14-2078S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-2078W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-5180S":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "HLC14-1060A":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "HLC20-1156W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC20-1156S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC16-2180S":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC14-2078A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC14-4192S":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "HLC16-2180W":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC14-2078E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC14-4192W":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "SHD07-2060A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC20-2192A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC14-4156A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC20-1084S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC14-4156S":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC14-4156W":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "FLY16-2076A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "ARC16-2120W":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "ARC16-2120S":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "IBC30-1120A":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "CHD10-2072A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ALC08-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-2096E":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "CHD10-2072E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ALC08-1036E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARC16-2120E":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "ARC16-2120A":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "ALC08-1036S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IBC30-1120S":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "ALC08-1036W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IBC30-1120W":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IDC12-2078S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3120E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ALC08-2096E":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "CLC08-1030E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ALC08-2096A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC14-3108E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-2078A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2078G":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2078E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ALC08-2096W":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "ALC08-2096S":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IBC30-1168W":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "IBC30-1168S":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "HLC20-1084A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC12-5180W":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "HLC14-3108A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC30-1168D":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "IBC30-1168A":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "AHD10-3120E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "CHD10-1048E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC14-3108W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "CHD10-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC14-3108S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-4180A":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC12-4180E":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC12-4180G":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC14-5192G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "SHD07-2096A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC16-1084A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ALC08-1030A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC12-4180S":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC12-4180W":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC16-1084W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC12-4144A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC16-1084S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "FLY16-2120A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC14-2120S":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "ARC16-1036E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-4156S":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "ARC16-1036A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-4156W":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC14-4156A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "ARC16-1036W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-4156E":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "ARC16-1036S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC16-1108W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC12-2060S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC16-1108S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC20-1132A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC16-1108G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC14-1036S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1084W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC16-1108A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC12-3132E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC20-1132W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC20-1132S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "AHD10-3120W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC12-1060A":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "HLC12-1048S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC16-2192A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC20-1084A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ARD12-3096A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC12-1048W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC12-4144W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-3096E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-4156G":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC14-2060G":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-3096S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC12-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "AHD10-3120S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARD12-3096W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC16-2192W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "SLC07-2084A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC12-1036W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC12-4144S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC12-2108A":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "HLC14-3144W":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "HLC14-4168A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC14-3144S":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "HLC12-2108W":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "IDC20-1120D":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "FLY16-3144A":{
            "penalty":0.0,
            "totalHorsePower":6.0
        },
        "HLC12-2108S":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "IDC12-1036S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC14-4168W":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC14-3144A":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "HLC14-4168S":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC12-4168A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC16-1156D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-2168W":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC16-2168A":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IBC16-1192G":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC16-2168D":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC16-2168E":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC16-2168G":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC14-2072E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC16-1132W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1192A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC12-3108W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "DTU03-2026A":{
            "penalty":0.0,
            "totalHorsePower":0.16
        },
        "IDC12-3108S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "DTU03-2026E":{
            "penalty":0.0,
            "totalHorsePower":0.16
        },
        "IBC30-1144A":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IDC12-3108G":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2120G":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "IDC12-3108E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2120E":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "HLC16-1132S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC12-3108A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2120A":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "IBC30-1180S":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "IBC30-1180W":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "ARC16-2084S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC12-4180W":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "ARC16-2084W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-1036E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC12-4180S":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IBC30-1180A":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "IBC16-1108D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC30-1180D":{
            "penalty":0.0,
            "totalHorsePower":25.0
        },
        "ARC16-2084A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CHD10-3120A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC12-4180A":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "ARC16-2084E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CHD10-3120E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "SHD07-2084A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC20-2192E":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC16-1072D":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-2078S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC16-1072W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC16-1096A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC14-2078W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC16-1060W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-2078A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC16-1072A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC16-1096W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1072G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1072E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC16-1096S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ARC16-1048S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-3108W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARC16-1048W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC16-1132A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC14-4144S":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC14-4168G":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC14-1060A":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "ARC16-1048A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-1048E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-4144G":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC14-4144E":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "HLC14-5192S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC14-4144A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "ALC08-1060S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ALC08-1060W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-3132W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "CLC08-2120E":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "AHD10-1036E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "FLY16-1051A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-2060A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "CLC08-2120A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "AHD10-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1060A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ALC08-1060E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "CLC08-2120W":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "AHD10-1036W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARD12-3132E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "CLC08-2120S":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "AHD10-1036S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARD12-3132A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARC16-3120S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1120G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1168S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ALC08-1048W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-2096S":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC12-2060E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC20-1108A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-1060E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1156S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-2084S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1156W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-2084W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC20-1108W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARC16-3120A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1120D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC20-1108S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1168D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARD12-2096A":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "ARD12-2084A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1156A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC20-1156G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-2084E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1156D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC14-1048A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC14-3132S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1108G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC14-3120W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-3132W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC20-1096S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1120G":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC16-2168A":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "HLC14-1060W":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "HLC14-3132A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-1048S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-3120G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-1048W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC20-1132S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC16-2168W":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "HLC16-2168S":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "CHD10-2060E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "CHD10-2120E":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "CHD10-2060A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "CHD10-2120A":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "IBC30-1144D":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IBC30-1132S":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IBC30-1132W":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IBC30-1144S":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IBC20-1084S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC30-1144W":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "HLC12-4156W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-2060W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC30-1132A":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IBC30-1132D":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "IDC20-1132W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC16-1084A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC16-1084D":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC20-1096W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1084G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC16-1096W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "AHD10-1042E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC12-5180G":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "HLC16-2192S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IBC16-1096S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC12-4156S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "SHD07-3120A":{
            "penalty":0.0,
            "totalHorsePower":2.25
        },
        "IDC20-1132G":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC20-1132E":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC12-5180S":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IDC12-2084G":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC20-1096D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1084W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC16-1096G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1084A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC16-1096D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1084G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC16-1060D":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC12-4156A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CLC08-1036W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "SHD07-2072A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "CLC08-1036S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC12-4168S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARC16-2096S":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC12-4168W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC20-1084D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1084G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ARC16-2096W":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IBC16-1096A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "CLC08-1036E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IBC16-1084S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC30-1192D":{
            "penalty":0.0,
            "totalHorsePower":30.0
        },
        "CLC08-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "SLC07-2120A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "ARC16-2096A":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC12-4168A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARC16-2096E":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC20-1084W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1096G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC20-1168A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC12-3096A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC20-1132A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "HLC12-3132A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC20-1096E":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "FLY16-1042A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC12-3132W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC12-3096S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC20-1168S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC16-1084G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC12-3132S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC12-3096W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC20-1168W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC12-2072W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1192W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC30-1096S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-4144A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC30-1096W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-4144E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "HLC12-5180A":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IDC12-4156W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-4156S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-4168G":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC30-1096A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-4144S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC20-1156D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC12-2072S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC30-1096D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-4156G":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-4156E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC20-1084D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC12-4156A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-2096S":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC14-1048S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2096W":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC14-1048W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-3096W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "AHD10-2048E":{
            "penalty":0.1,
            "totalHorsePower":1.0
        },
        "HLC14-2060S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-3096S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "AHD10-2048A":{
            "penalty":0.1,
            "totalHorsePower":1.0
        },
        "HLC14-2060W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-1048A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC30-1192S":{
            "penalty":0.0,
            "totalHorsePower":30.0
        },
        "IDC12-2096G":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC12-2096E":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC12-3096G":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC14-2060A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-3096E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "AHD10-2048W":{
            "penalty":0.1,
            "totalHorsePower":1.0
        },
        "IDC12-3096A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "AHD10-2048S":{
            "penalty":0.1,
            "totalHorsePower":1.0
        },
        "ARC16-3132S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1156W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARC16-3132W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-2084A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3108S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC30-1192W":{
            "penalty":0.0,
            "totalHorsePower":30.0
        },
        "IDC12-2084E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3108W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1156S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARC16-3132A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARC16-3132E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC20-1144S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARC16-3108A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-2084S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3108E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC12-2084W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC14-3120W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARD12-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1072A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC14-3120S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARD12-1048E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1072E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC20-2192S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-3120A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ALC08-2120W":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "HLC20-2192W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-3120E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ALC08-2120S":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "HLC12-4192A":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "ARD12-1048S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1072S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-1048W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1072W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC14-3120A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ALC08-2120E":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "HLC12-4192W":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "HLC20-2192A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARD12-3120S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ALC08-2120A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "HLC12-4192S":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC14-2084E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-3120W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "AHD10-2096S":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IBC30-1156A":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "AED08-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "AHD10-2096W":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "AED08-1048E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC30-1192A":{
            "penalty":0.0,
            "totalHorsePower":30.0
        },
        "CHD10-2108E":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "FLY16-1072A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CHD10-2108A":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "AHD10-2096A":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IBC30-1156S":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "AHD10-2096E":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IBC30-1156W":{
            "penalty":0.0,
            "totalHorsePower":20.0
        },
        "ALC08-1042E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "CLC08-1048W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "CLC08-1048S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-1036E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC20-1060A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1096S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC20-1060D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1060G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1096W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "CLC08-1048E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-1036S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1042W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC16-2168S":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "CLC08-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ARD12-1036W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ALC08-1042S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IBC20-1096A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC20-1060S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1096D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1084S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1060W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1096G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC20-1084W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "AED08-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC20-2192G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC20-2192D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "AED08-1036E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC20-1144A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC20-1108S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-2180A":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC20-1108W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC20-1096A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1144G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC14-1036A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-1072S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC20-2192W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC16-1120D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC20-1096W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1108A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC20-1096S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1108G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1108D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1108E":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-1120W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC12-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC16-1120S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-1060S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1168S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "FLY16-1066A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IBC20-1168W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC14-5192W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC14-5192E":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1060D":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC14-5192A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1120E":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-1060G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1060A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC16-1120A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-5192A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1168A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC20-1168G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC20-1168D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "AHD10-3108E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "AHD10-3108A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC16-1156G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARD12-2108E":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "HLC12-3108A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARD12-2108A":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "IDC16-1156A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "AHD10-3108W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "AHD10-3108S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "SHD07-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.75
        },
        "ARD12-2108W":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "HLC12-3108S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARD12-2108S":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "HLC12-3108W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC16-2180S":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "HLC12-2078S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3144S":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "HLC12-2078W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3144W":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "AHD10-1048W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "CHD10-1036E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "AHD10-1048S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "CHD10-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARC16-3144A":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "HLC12-2078A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC20-1144W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "ARC16-3144E":{
            "penalty":-0.1,
            "totalHorsePower":3.0
        },
        "AHD10-1048E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC12-4192G":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "AHD10-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "ARC16-3096E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC14-5192S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ARC16-3096A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-1042A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-2060A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-2108S":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "ARC16-2060E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-2108W":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "HLC14-1042W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3096W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC14-1042S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARC16-3096S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARC16-2060S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-2108A":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "IDC12-2108G":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "ARC16-2060W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-2108E":{
            "penalty":-0.125,
            "totalHorsePower":1.0
        },
        "IDC14-3096E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC14-3096G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC14-3096A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC20-1180E":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-2120W":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "ARD12-1060A":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "IDC20-1168E":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-2096S":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "ARD12-1060E":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "HLC12-2096A":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC14-2096W":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC14-3096W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC14-1042A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-3096S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "HLC12-2096W":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC14-2096A":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "ARD12-1060S":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "HLC12-2096S":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC14-2096E":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "ARD12-1060W":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "IDC14-2096G":{
            "penalty":-0.1,
            "totalHorsePower":2.0
        },
        "IDC16-2192A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "ARC16-1042A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-2192E":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC16-2192D":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC16-2192G":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "ARC16-1042E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "AED08-1060A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC14-5180A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "AED08-1060E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC14-5180E":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ARC16-1042S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-2192S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "ARC16-1042W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-2192W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC14-3120E":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ALC08-1048A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC14-5180W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ALC08-1048E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "CHD10-3096E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-3132W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "CHD10-3096A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC12-4168W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC20-1168D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-5192W":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IDC20-1168G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-5192S":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IDC20-1180G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC16-1132S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC12-5192G":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IDC12-5192E":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "ARC16-4144S":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC12-4168S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC20-1120A":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC20-1060A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC12-2084S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC20-1060G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1096W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1060E":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC12-2084W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-5192W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC12-4144G":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "SLC07-2096A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "IDC20-1060S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC12-2084A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC20-1120S":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC20-1060W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1120W":{
            "penalty":0.0,
            "totalHorsePower":10.0
        },
        "IDC14-2078G":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ARD12-2072E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC12-1060S":{
            "penalty":-0.15,
            "totalHorsePower":0.5
        },
        "HLC12-3120S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARD12-2072A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "ARD12-2120S":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "HLC12-3120W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC14-5180W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1108W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC14-5180S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1108S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ARD12-2120E":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "HLC12-3120A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "ARD12-2072W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-1132G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARD12-2120A":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "IDC16-1132A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARD12-2072S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC16-1108E":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1108D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1108G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1108A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC16-1168W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC14-5180A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1084E":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1072A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ALC08-1030E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC14-3120S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "AHD10-3120A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC20-1180W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-2060A":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC12-4168E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "ALC08-1030W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "ALC08-1030S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "HLC14-2120S":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "IDC14-1042S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "AHD10-3096E":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC14-2120W":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "AHD10-3096A":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC14-2060E":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CLC08-1042A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC12-4144W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "CLC08-1042E":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC12-1036G":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "AHD10-3096W":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "HLC14-2120A":{
            "penalty":-0.15,
            "totalHorsePower":2.0
        },
        "AHD10-3096S":{
            "penalty":0.0,
            "totalHorsePower":1.5
        },
        "IDC12-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "CLC08-1042S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC20-1156A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "CLC08-1042W":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "SLC07-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC12-2120A":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "AHD10-2072S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2060G":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2120E":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "AHD10-2072W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2120G":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "IBC20-1108D":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC14-4192E":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "HLC12-1036A":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC16-1060A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1108A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "AHD10-2072A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2072S":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC12-2120S":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "AHD10-2072E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-4168A":{
            "penalty":0.0,
            "totalHorsePower":4.0
        },
        "IDC12-2120W":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "HLC12-1036S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC16-1060W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1108W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC12-1036W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC16-1060S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC20-1108S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARD12-3144A":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "ARD12-3144E":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "ARC16-2108E":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IBC16-1072W":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARC16-2108A":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IBC16-1072S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARD12-3144S":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IBC16-1156W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "ARD12-3144W":{
            "penalty":-0.1,
            "totalHorsePower":1.5
        },
        "IBC16-1072D":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IBC16-1072G":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARC16-2108W":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IBC16-1072A":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "IDC14-2060S":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-3108S":{
            "penalty":0.0,
            "totalHorsePower":3.0
        },
        "ARC16-2108S":{
            "penalty":-0.125,
            "totalHorsePower":2.0
        },
        "IDC16-2180G":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC16-2180D":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC14-5180G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC16-1144S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC16-1156A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC12-2072A":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "HLC16-1144A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1120G":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1156S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IBC16-1120A":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC12-1048G":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IDC12-1048E":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "HLC16-1156W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC16-2180W":{
            "penalty":0.0,
            "totalHorsePower":8.0
        },
        "IDC20-1072S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "HLC16-1156S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC14-2060W":{
            "penalty":0.0,
            "totalHorsePower":2.0
        },
        "IDC14-4180W":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "IDC12-1048S":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC16-1120W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC16-1144S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC12-1048W":{
            "penalty":0.0,
            "totalHorsePower":0.5
        },
        "IBC16-1120S":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC16-1144W":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "HLC16-1108S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC14-1042G":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IDC14-1042E":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "IBC20-1072S":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1180A":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IBC20-1072W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1180D":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC14-4180S":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "HLC14-1060S":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "DTU03-1018E":{
            "penalty":0.0,
            "totalHorsePower":0.08
        },
        "IDC14-4192S":{
            "penalty":-0.1,
            "totalHorsePower":4.0
        },
        "IDC14-1042W":{
            "penalty":0.0,
            "totalHorsePower":1.0
        },
        "DTU03-1018A":{
            "penalty":0.0,
            "totalHorsePower":0.08
        },
        "IDC20-1180S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "HLC16-1108W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC12-5180E":{
            "penalty":0.0,
            "totalHorsePower":2.5
        },
        "IBC20-1072G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IBC20-1072D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1156E":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC16-1144E":{
            "penalty":0.0,
            "totalHorsePower":7.5
        },
        "IDC20-1156G":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC20-1072A":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1072D":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1072E":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "IDC20-1072G":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "ARC16-1060S":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "CLC08-2096S":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "ARC16-1060W":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "CLC08-2096W":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "ALC08-1048S":{
            "penalty":0.0,
            "totalHorsePower":0.2
        },
        "IDC20-1156W":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC12-2096A":{
            "penalty":-0.1,
            "totalHorsePower":1.0
        },
        "IDC20-1156S":{
            "penalty":0.0,
            "totalHorsePower":15.0
        },
        "IDC20-1072W":{
            "penalty":0.0,
            "totalHorsePower":5.0
        },
        "CLC08-2096A":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "ARC16-1060A":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        },
        "CLC08-2096E":{
            "penalty":0.0,
            "totalHorsePower":0.4
        },
        "ARC16-1060E":{
            "penalty":-0.15,
            "totalHorsePower":1.0
        }
    }
}